import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from 'src/hooks';

// Components
import Tabs from 'src/ui/Tabs';
import NewTherapyAv from 'src/views/admin/therapy/NewTherapyAv';
import OnboardingTherapy from 'src/views/admin/therapy/onboardingTherapy';
import TherapistProfile from 'src/views/admin/therapy/TherapistProfile';
import { TherapistMeUseCase } from 'src/services/therapy/useCases';
import { setCompletedOnboardingQuestions } from 'src/redux/slices/therapy.slice';

const TherapyDetails = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const role = useAppSelector((state) => state.auth.role);
  const TherapistDetail = useAppSelector((state) => state.therapy.TherapistDetail);

  const [activeTab, setActiveTab] = useState(1);

  const { t } = useTranslation(['therapyDetail']);

  useEffect(() => {
    if (role === 'therapist') {
      dispatch(TherapistMeUseCase());
    }
  }, [dispatch, role]);

  const editOnboardingQuestions = () => {
    dispatch(setCompletedOnboardingQuestions(''));
    if (role === 'therapist') {
      navigate(`/therapist/${TherapistDetail.id}/therapy-detail/OnboardingTherapy`);
    } else navigate('OnboardingTherapy');
  };

  const shouldShowEditButton = activeTab === 3 && TherapistDetail?.therapistAnswers?.length > 0;

  return (
    <div className='coach-detail'>
      <Tabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        navbar={true}
        backBtn={true}
        availability={false}
        isEdit={shouldShowEditButton}
        clickEditHandler={editOnboardingQuestions}
        data={{
          first: role === 'admin' ? t('header') : t('currentCoach'),
          second: t('av'),
          third: t('onboarding'),
        }}
        content={{
          one: <TherapistProfile />,
          two: <NewTherapyAv />,
          three: <OnboardingTherapy />,
        }}
      />
    </div>
  );
};

export default TherapyDetails;
